import { Injectable } from "@angular/core";
import { ObjectUtils } from "primeng/utils";

@Injectable({
    providedIn: "root",
})
export class DataImportExportService {
    constructor() {}

    /**
     * Creates and exports a csv file from any flat unnested object.
     *
     * @param data A flat unnested object that is to be written to the file.
     * @param columns An array of column tuples, where index 0 matches the key name in the data and index 1 is how the column should be written.
     *   Example: ["projectId", "Project ID"]. By Default will create column headings with Object keys if undefined.
     * @param exportFilename The name the file should have without an extension. This function will append the extension.
     * @param csvSeparator An optional separator for the CSV records. Defaults to "," if undefined.
     */
    public exportCSV(data: any[], columns: [string, string][], exportFilename: string, csvSeparator?: String) {
        let csv = "";
        let separator = csvSeparator ? csvSeparator : ",";

        //headers
        for (let i = 0; i < columns.length; i++) {
            let column = columns[i];
            csv += '"' + column[1] + '"';

            if (i < columns.length - 1) {
                csv += separator;
            }
        }

        //body
        data.forEach((row, i) => {
            csv += "\n";

            for (let i = 0; i < columns.length; i++) {
                let column = columns[i][0];

                if (row[column] !== undefined) {
                    csv += '"' + row[column] + '"';
                }

                if (i < columns.length - 1) {
                    csv += separator;
                }
            }
        });

        let blob = new Blob([csv], {
            type: "text/csv;charset=utf-8;",
        });

        let link = document.createElement("a");
            link.style.display = "none";
            document.body.appendChild(link);
            if (link.download !== undefined) {
                link.setAttribute("href", URL.createObjectURL(blob));
                link.setAttribute("download", exportFilename + ".csv");
                link.click();
            } else {
                csv = "data:text/csv;charset=utf-8," + csv;
                window.open(encodeURI(csv));
            }
            document.body.removeChild(link);
    }

    /**
     * Creates An Array of tuples from an Objects keys to be used as "columns" in the exportCSV function.
     *
     * @param data a flat unnested object
     */
    public createExportColumns(data: any[]): [string, string][] {
        let columns: [string, string][] = [];
        Object.keys(data[0]).forEach(key => {
          columns.push([key, key]);
        });
        return columns;
    }
}
